import { ArrowSquareOut } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import Skeleton from "common/components/ui/Skeleton";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";

import type { FunctionComponent, JSX, SVGProps } from "react";

type IntegrationItemProps = {
  title: string;
  description: string;
  icon: FunctionComponent<SVGProps<SVGSVGElement>>;
} & (
  | { redirectUrl: string; settingsComponent?: never; isLoading?: boolean }
  | {
      redirectUrl?: never;
      settingsComponent: JSX.Element;
      isLoading?: never;
    }
  | {
      redirectUrl?: never;
      settingsComponent?: never;
      isLoading: boolean;
    }
);

export default function IntegrationItem({
  title,
  description,
  icon: Icon,
  redirectUrl,
  settingsComponent,
}: IntegrationItemProps) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  let topRightComponent = <Skeleton className="rounded-full size-8" />;

  if (redirectUrl) {
    topRightComponent =
      title === "Slack" ? (
        <Button
          intent="iconOnly"
          variant="secondary-black"
          size="sm"
          onClick={() =>
            window.open(
              `${redirectUrl}${workspaceId}_${Math.floor(Date.now() / Math.random())}`,
              "_blank",
              "noopener,noreferrer",
            )
          }
        >
          <ArrowSquareOut />
        </Button>
      ) : (
        <Button asChild intent="iconOnly" variant="secondary-black" size="sm">
          <Link to={redirectUrl} target="_blank">
            <ArrowSquareOut />
          </Link>
        </Button>
      );
  } else if (settingsComponent) {
    topRightComponent = settingsComponent;
  }

  return (
    <div className="flex flex-col gap-y-2 rounded-3xl border border-black-200 p-2 bg-white">
      <div className="flex justify-between gap-2">
        {/* Integration icon */}
        <Icon />
        {topRightComponent}
      </div>

      {/* Title */}
      <h3 className="text-xl-bold">{title}</h3>

      {/* Description */}
      <p className="text-black-600">{description}</p>
    </div>
  );
}
